const rankings = [
  { rank: 1, title: '我独自升级', tag: '韩漫·暗黑奇幻', heat: '9.9', change: 'up', desc: '系统流天花板，全网热度断层第一' },
  { rank: 2, title: '咒术回战', tag: '日漫·热血战斗', heat: '9.8', change: 'same', desc: '每周更新引爆讨论区，话题不断' },
  { rank: 3, title: '狐妖小红娘', tag: '国漫·古风奇幻', heat: '9.7', change: 'up', desc: '国漫口碑之作，画风与剧情齐飞' },
  { rank: 4, title: '全知读者视角', tag: '韩漫·生存冒险', heat: '9.6', change: 'up', desc: '脑洞大开的生存系神作，持续霸榜' },
  { rank: 5, title: '电锯人', tag: '日漫·暗黑热血', heat: '9.5', change: 'down', desc: '藤本树狂气之作，每次更新都是名场面' },
  { rank: 6, title: '斗罗大陆', tag: '国漫·玄幻热血', heat: '9.4', change: 'down', desc: '国漫经典长篇，完结倒计时热度飙升' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            TOP 榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门排行
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            千万漫友共同选择的优质漫画，热度排名实时更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="flex items-center gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-100/50 px-3 -mx-3 rounded-md transition-colors"
            >
              <span
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.tag}</span>
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-line text-green-500 text-xs"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-line text-red-400 text-xs"></i>
                  )}
                  {item.change === 'same' && (
                    <span className="text-xs text-foreground-400">—</span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <span className="text-sm font-bold text-accent-600 shrink-0">{item.heat}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#ranking"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}